import React from "react";

export const AccountSymbol = () => (
  <img
    src="https://cdn.shopify.com/s/files/1/0268/4219/files/account-icon_b03a9b5a-2642-452e-b74e-f4dfc5493385.svg?v=1717402551"
    alt="My Account"
  />
);
